import React, { PureComponent } from 'react';
import { object, string } from 'prop-types';
import CircleImage from '../SolvPatternLibrary/CircleImage';
import { safeGet } from '../../core/util/object';
import { isEmpty } from '../../core/util/empty';
import { THUMBNAIL_SMALL } from '../SolvPatternLibrary/Picture/util';

class AutocompleteIcon extends PureComponent {
  static propTypes = {
    suggestion: object,
    className: string,
  };

  getImageForProviderType = providerType => {
    switch (providerType) {
      case 'ob-gyn':
        return '/images/icons/universal_search/obgyn.svg';
      case 'optometrist':
        return '/images/icons/universal_search/optometrist.svg';
      case 'dentist':
        return '/images/icons/universal_search/dentist.svg';
      case 'chiropractor':
        return '/images/icons/universal_search/chiropractor.svg';
      case 'dermatologist':
        return '/images/icons/universal_search/derm.svg';
      case 'allergist':
        return '/images/icons/universal_search/allergist.svg';
      case 'imaging':
        return '/images/icons/universal_search/imaging.svg';
      default:
      case 'urgent_care':
        return '/images/icons/universal_search/uc.svg';
    }
  };

  render() {
    const {
      className,
      suggestion: { fullDoc, icon },
    } = this.props;

    if (icon) return icon;

    const locationImages = safeGet(fullDoc)('location_images');
    const docType = safeGet(fullDoc)('type');
    const providerType = safeGet(fullDoc)('provider_type');

    if (docType === 'provider-type' || docType === 'free-text') {
      return <img className={className} src={this.getImageForProviderType(providerType)} />;
    }

    if (docType === 'location' && !isEmpty(locationImages)) {
      const imageObject = {
        fullRes: locationImages.full_res,
        webp: locationImages.webp,
        jp2: locationImages.jp2,
        thumbnail128: locationImages.thumbnail128,
        thumbnail200: locationImages.thumbnail200,
      };
      return (
        <CircleImage
          className={className}
          imageObject={imageObject}
          showThumbnail
          thumbnailSize={THUMBNAIL_SMALL}
        />
      );
    }

    return null;
  }
}

export default AutocompleteIcon;
